import { IStyleConfig, mergeStyles } from '@cian/utils';

import React, { Component } from 'react';

import * as styles from './index.css';

export interface ISvgScalableProps {
  viewBox: string;
  width?: string | number;
  height?: string | number;
}

export class SvgScalable extends Component<React.PropsWithChildren<ISvgScalableProps>> {
  private element: SVGSVGElement;

  public componentDidMount() {
    this.updateSizes();
  }

  public componentDidUpdate() {
    this.updateSizes();
  }

  public render() {
    return (
      // eslint-disable-next-line react/forbid-elements
      <svg ref={(element: SVGSVGElement) => (this.element = element)} {...this.props}>
        {this.props.children}
      </svg>
    );
  }

  private updateSizes() {
    if (typeof this.props.width === 'undefined' && typeof this.props.height === 'undefined') {
      throw new Error('Either width or height should be set');
    }

    if (typeof this.props.width !== 'undefined' && typeof this.props.height !== 'undefined') {
      return;
    }

    const boundingClientRect = this.element.getBoundingClientRect();
    const bBox = this.element.getBBox();

    if (typeof this.props.height !== 'undefined') {
      const height = boundingClientRect.height;

      const ratio = bBox.width / bBox.height;
      const width = height * ratio;

      this.element.setAttribute('width', `${Math.round(width)}`);
    } else {
      const width = boundingClientRect.width;

      const ratio = bBox.height / bBox.width;
      const height = width * ratio;

      this.element.setAttribute('height', `${Math.round(height)}`);
    }
  }
}

export interface IImageNoneProps {
  /**
   * Цвет фона
   */
  bgColor?: string;
  /**
   * Цвет иконки
   */
  iconColor?: string;
  /**
   * Специальные стили для контейнера (фона)
   */
  containerStyle?: IStyleConfig;
  /**
   * Специальные стили иконки
   */
  iconStyle?: IStyleConfig;
}

export class ImageNone extends Component<IImageNoneProps, {}> {
  public static defaultProps = {
    bgColor: '#C9C9C9',
    iconColor: '#E4E4E4',
  };

  public render() {
    return (
      <div {...mergeStyles(styles['container'], this.props.containerStyle, { backgroundColor: this.props.bgColor })}>
        <SvgScalable height="45%" viewBox="0 0 157 208" {...mergeStyles(styles['icon'], this.props.iconStyle)}>
          <g fill={this.props.iconColor}>
            {/* tslint:disable:max-line-length */}
            <path d="M154.925 18.403L74.38.473c-1.39-.308-2.768.568-3.077 1.958L65.7 27.6l8.353-1.926 3.12-14.006c.308-1.39 1.688-2.266 3.078-1.957l65.45 14.57c1.39.31 2.27 1.69 1.96 3.08l-15.69 70.47c-.31 1.39-1.68 2.27-3.07 1.96l-24.96-5.55 4.5 19.49 24.09 5.36c1.39.31 2.77-.57 3.08-1.96l21.3-95.63c.31-1.39-.56-2.77-1.96-3.08z" />
            <path d="M119.955 37.925c-2.945-4.793-7.29-7.34-12.955-7.52-3.93-.125-7.398 1.198-10.315 3.73-2.485 2.157-4.096 4.742-4.838 7.715L99.1 73.292l.88 2.838c2.962-3.274 5.73-6.33 8.493-9.39 2.96-3.274 5.867-6.598 8.886-9.813 2.5-2.666 4.09-5.685 4.59-9.35.46-3.492-.2-6.718-2-9.652zm-6.447 9.512c-.93 4.05-4.603 5.945-8.324 5.278-3.74-.856-6.2-4.716-5.29-8.45.937-3.843 4.39-6.117 8.472-5.212 3.528.778 6.122 4.11 5.142 8.384zm-5.438 76.223L86.05 28.192c-.276-1.19-1.336-1.998-2.51-1.998-.19 0-.386.02-.582.067L2.55 44.81c-1.39.318-2.254 1.7-1.934 3.09l22.022 95.464c.273 1.195 1.336 2.002 2.51 2.002.192 0 .386-.023.582-.067l80.407-18.54c1.39-.33 2.253-1.71 1.934-3.1zm-13.527-12.755L29.21 125.97c-1.386.32-2.77-.544-3.09-1.934L9.89 53.694c-.32-1.39.547-2.772 1.934-3.094l65.33-15.065c1.388-.32 2.773.547 3.093 1.934l16.227 70.34c.32 1.38-.547 2.77-1.934 3.09z" />
            <path d="M48.263 59.36c4.3 2.68 8.664 5.395 13.314 8.288-.21-1.962-.714-3.535-1.057-5.133-.338-1.583-.722-3.156-1.104-4.81 3.497-.805 6.826-1.574 10.268-2.368.147.526.29.977.397 1.434.71 3.01 1.38 6.03 2.1 9.03.75 3.09 1.57 6.15 2.31 9.24.16.68.55 1.06 1.11 1.39 2.83 1.71 5.65 3.43 8.47 5.15.41.25.8.54 1.17.79-.26 1.06-6.23 10.82-8.28 13.6-1.35-.65-2.59-1.56-3.89-2.35-1.32-.8-2.62-1.63-3.93-2.45l-4.04-2.52c-1.31-.82-2.62-1.63-3.92-2.45l-3.93-2.45c-1.3-.82-2.61-1.63-4.02-2.51-1 1.26-1.72 2.63-2.54 3.91-.83 1.3-1.64 2.62-2.46 3.93L45.7 93.1c-.82 1.31-1.634 2.62-2.455 3.93l-2.454 3.93-2.37 3.784-13.25-8.28L48.3 59.388M22.52 175.86h-4.83v11.134H5.52v-11.14H.69v25.89h4.83V190.43h12.153v11.316h4.832v-25.89zm16.892 14.59h-8.34c.2-1.34.67-2.37 1.403-3.1s1.74-1.09 3.015-1.09c.657 0 1.233.11 1.728.33.493.22.902.52 1.224.902.32.38.562.828.723 1.335.16.506.24 1.05.24 1.62zm-8.43 2.664h11.36c.405 0 .68-.114.82-.35.14-.23.215-.68.215-1.35 0-1.324-.2-2.503-.6-3.535s-.95-1.91-1.655-2.62c-.706-.71-1.547-1.25-2.525-1.62-.978-.37-2.046-.55-3.203-.55-1.37 0-2.6.24-3.69.71-1.093.48-2.017 1.12-2.775 1.94-.76.82-1.34 1.78-1.75 2.88-.41 1.1-.61 2.28-.61 3.53 0 1.61.23 3.03.7 4.25.46 1.22 1.1 2.25 1.91 3.08.81.83 1.76 1.45 2.86 1.88 1.1.42 2.28.63 3.56.63.64 0 1.31-.05 1.99-.15.68-.1 1.36-.26 2.02-.49.66-.24 1.29-.55 1.9-.93.61-.39 1.16-.87 1.65-1.45l-1.27-1.61c-.18-.278-.46-.415-.83-.415-.28 0-.56.08-.85.25s-.63.35-1.02.554c-.39.2-.84.39-1.36.556-.52.17-1.14.25-1.85.25-.72 0-1.37-.11-1.96-.33-.59-.22-1.1-.553-1.53-1-.43-.445-.78-1.01-1.04-1.7-.27-.69-.43-1.5-.5-2.446zm31.46-6.46v-3.28H44.93v3.277h6.53v15.1h4.42v-15.09h6.552zm24.143 12.065v-12.34c1.777.13 3.152.73 4.124 1.8.97 1.06 1.45 2.52 1.45 4.37s-.49 3.3-1.46 4.37c-.97 1.06-2.35 1.66-4.13 1.79zm-3.87-12.34v12.33c-.884-.08-1.668-.26-2.354-.57-.68-.31-1.27-.72-1.75-1.24s-.85-1.14-1.1-1.88-.37-1.56-.37-2.48c0-.92.13-1.74.38-2.48.26-.73.62-1.36 1.11-1.89.49-.52 1.07-.94 1.76-1.24.69-.31 1.47-.49 2.35-.57zm4.007-3.28v-7.25H82.57v7.26c-1.47.08-2.808.36-4.02.83-1.21.47-2.25 1.11-3.115 1.92-.865.81-1.536 1.78-2.013 2.9-.478 1.12-.717 2.37-.717 3.76 0 1.39.24 2.66.716 3.78.48 1.13 1.15 2.1 2.02 2.91.87.81 1.91 1.45 3.12 1.93 1.21.47 2.55.76 4.02.84v5.91h4.15V202c1.47-.085 2.81-.365 4.02-.843 1.21-.477 2.25-1.122 3.12-1.934s1.53-1.783 2.01-2.91c.48-1.13.71-2.39.71-3.788 0-1.385-.24-2.638-.71-3.76-.48-1.122-1.15-2.09-2.01-2.9s-1.9-1.454-3.11-1.926c-1.21-.47-2.55-.75-4.02-.84zm21.313-.02c-1.372 0-2.62.22-3.74.66-1.122.44-2.08 1.06-2.872 1.88-.79.81-1.406 1.8-1.84 2.97-.438 1.17-.656 2.47-.656 3.92 0 1.45.218 2.77.653 3.94.435 1.17 1.05 2.16 1.843 2.99.792.82 1.75 1.45 2.87 1.89 1.123.44 2.37.66 3.74.66 1.36 0 2.6-.22 3.715-.67 1.116-.44 2.07-1.08 2.863-1.9.79-.82 1.4-1.82 1.83-2.99s.64-2.48.64-3.94c0-1.45-.21-2.75-.64-3.92-.43-1.17-1.04-2.17-1.83-2.98s-1.75-1.44-2.86-1.88c-1.11-.45-2.35-.67-3.71-.67zm0 15.52c-1.55 0-2.7-.52-3.445-1.55s-1.12-2.54-1.12-4.51c0-1.97.373-3.48 1.12-4.52s1.893-1.57 3.444-1.57c1.53 0 2.66.52 3.39 1.55.737 1.04 1.104 2.55 1.104 4.53s-.367 3.49-1.1 4.51c-.734 1.02-1.865 1.54-3.392 1.54zm28.187-11.96v-3.28h-17.51v3.27h6.53v15.09h4.42v-15.09h6.55zm10.73-3.57c-1.37 0-2.62.22-3.74.66-1.12.44-2.08 1.06-2.87 1.88s-1.406 1.8-1.84 2.97c-.436 1.17-.654 2.48-.654 3.92 0 1.45.216 2.77.65 3.94s1.05 2.16 1.843 2.99c.79.82 1.75 1.45 2.87 1.89 1.12.44 2.37.66 3.74.66 1.36 0 2.6-.22 3.72-.67 1.12-.45 2.07-1.08 2.86-1.9.8-.83 1.41-1.82 1.84-2.99.43-1.17.64-2.48.64-3.94 0-1.45-.21-2.75-.64-3.92-.43-1.17-1.04-2.17-1.83-2.98s-1.74-1.44-2.86-1.88c-1.11-.44-2.35-.66-3.71-.66zm0 15.52c-1.55 0-2.7-.52-3.442-1.55-.745-1.04-1.12-2.54-1.12-4.51 0-1.97.375-3.48 1.12-4.52.747-1.04 1.895-1.57 3.446-1.57 1.528 0 2.66.51 3.39 1.55.736 1.04 1.103 2.55 1.103 4.53s-.37 3.482-1.11 4.51c-.73 1.023-1.87 1.54-3.39 1.54z" />
            {/* tslint:enable:max-line-length */}
          </g>
        </SvgScalable>
      </div>
    );
  }
}
